export default __webpack_public_path__ + "static/map-light-blue-4ae8b0dead5fb0da0b701a40375fe11d.webp";